export const cardList = [
  {
    id: 161,
    cuda_type: 'NVIDIA A100-SXM4-80GB',
    hash_rate: 215.04,
  },
  {
    id: 270,
    cuda_type: 'RTX 5090',
    hash_rate: 210.32,
  },
  {
    id: 249,
    cuda_type: 'NVIDIA A800 80GB PCIe',
    hash_rate: 204.8,
  },
  {
    id: 258,
    cuda_type: 'NVIDIA A100 80GB PCIe',
    hash_rate: 184.1375,
  },
  {
    id: 247,
    cuda_type: 'NVIDIA A100-SXM4-40GB',
    hash_rate: 174.08,
  },
  {
    id: 271,
    cuda_type: 'NVIDIA A800-SXM4-40GB',
    hash_rate: 174.08,
  },
  {
    id: 11,
    cuda_type: 'NVIDIA A100-PCIE-40GB',
    hash_rate: 164.683,
  },
  {
    id: 168,
    cuda_type: 'CMP 170HX',
    hash_rate: 159.7228,
  },
  {
    id: 52,
    cuda_type: 'NVIDIA Graphics Device',
    hash_rate: 151.9733,
  },
  {
    id: 209,
    cuda_type: 'RTX 4090',
    hash_rate: 124.908,
  },
  {
    id: 203,
    cuda_type: 'RTX 3090 Ti',
    hash_rate: 123.38,
  },
  {
    id: 45,
    cuda_type: 'NVIDIA GeForce RTX 3090 Ti',
    hash_rate: 118.69,
  },
  {
    id: 202,
    cuda_type: 'RTX 3090',
    hash_rate: 116.1385,
  },
  {
    id: 51,
    cuda_type: 'NVIDIA GeForce RTX 4090',
    hash_rate: 113.5371,
  },
  {
    id: 265,
    cuda_type: 'NVIDIA GeForce RTX 4090 D',
    hash_rate: 113.4661,
  },
  {
    id: 201,
    cuda_type: 'RTX 3080 Ti',
    hash_rate: 111.8958,
  },
  {
    id: 269,
    cuda_type: 'RTX 5080',
    hash_rate: 111.24,
  },
  {
    id: 155,
    cuda_type: 'NVIDIA RTX 6000 Ada Generation',
    hash_rate: 105.97,
  },
  {
    id: 44,
    cuda_type: 'NVIDIA GeForce RTX 3090',
    hash_rate: 105.4843,
  },
  {
    id: 252,
    cuda_type: 'RTX 4090 D',
    hash_rate: 104.67,
  },
  {
    id: 166,
    cuda_type: 'gfx906',
    hash_rate: 103.1437,
  },
  {
    id: 42,
    cuda_type: 'NVIDIA GeForce RTX 3080 Ti',
    hash_rate: 102.6149,
  },
  {
    id: 172,
    cuda_type: 'CMP 90HX',
    hash_rate: 96.5175,
  },
  {
    id: 68,
    cuda_type: 'Tesla V100-PCIE-16GB',
    hash_rate: 93.124,
  },
  {
    id: 66,
    cuda_type: 'Tesla V100-DGXS-16GB',
    hash_rate: 93.0125,
  },
  {
    id: 16,
    cuda_type: 'NVIDIA CMP 90HX',
    hash_rate: 91.3337,
  },
  {
    id: 233,
    cuda_type: 'gfx1100',
    hash_rate: 90.44,
  },
  {
    id: 72,
    cuda_type: 'Tesla V100S-PCIE-32GB',
    hash_rate: 89.0113,
  },
  {
    id: 69,
    cuda_type: 'Tesla V100-PCIE-32GB',
    hash_rate: 87.515,
  },
  {
    id: 40,
    cuda_type: 'NVIDIA GeForce RTX 3080',
    hash_rate: 87.4959,
  },
  {
    id: 244,
    cuda_type: 'RTX 4080 SUPER',
    hash_rate: 87.27,
  },
  {
    id: 71,
    cuda_type: 'Tesla V100-SXM2-32GB',
    hash_rate: 87.1709,
  },
  {
    id: 61,
    cuda_type: 'NVIDIA RTX A6000',
    hash_rate: 86.845,
  },
  {
    id: 60,
    cuda_type: 'NVIDIA RTX A5000',
    hash_rate: 86.73,
  },
  {
    id: 59,
    cuda_type: 'NVIDIA RTX A4500',
    hash_rate: 85.864,
  },
  {
    id: 67,
    cuda_type: 'Tesla V100-FHHL-16GB',
    hash_rate: 85.32,
  },
  {
    id: 199,
    cuda_type: 'RTX 3080',
    hash_rate: 84.1491,
  },
  {
    id: 267,
    cuda_type: 'NVIDIA CMP 100-210',
    hash_rate: 83.625,
  },
  {
    id: 50,
    cuda_type: 'NVIDIA GeForce RTX 4080',
    hash_rate: 83.1139,
  },
  {
    id: 156,
    cuda_type: 'GeForce RTX 3080',
    hash_rate: 81.97,
  },
  {
    id: 248,
    cuda_type: 'NVIDIA GeForce RTX 4080 SUPER',
    hash_rate: 80.982,
  },
  {
    id: 167,
    cuda_type: 'gfx1100 OpenCL 2.0',
    hash_rate: 80.47,
  },
  {
    id: 208,
    cuda_type: 'RTX 4080',
    hash_rate: 78.0167,
  },
  {
    id: 10,
    cuda_type: 'gfx906:sramecc+:xnack- OpenCL 2.0',
    hash_rate: 77.9855,
  },
  {
    id: 226,
    cuda_type: 'RTX 4070 Ti SUPER',
    hash_rate: 75.4,
  },
  {
    id: 212,
    cuda_type: 'RTX A5000',
    hash_rate: 74.76,
  },
  {
    id: 171,
    cuda_type: 'CMP 70HX',
    hash_rate: 72.1656,
  },
  {
    id: 70,
    cuda_type: 'NVIDIA GeForce RTX 4070 Ti SUPER',
    hash_rate: 72.025,
  },
  {
    id: 223,
    cuda_type: 'gfx906:sramecc+:xnack-',
    hash_rate: 71.2751,
  },
  {
    id: 197,
    cuda_type: 'RTX 3070 Ti',
    hash_rate: 70.9201,
  },
  {
    id: 15,
    cuda_type: 'NVIDIA CMP 70HX',
    hash_rate: 70.0275,
  },
  {
    id: 70,
    cuda_type: 'Tesla V100-SXM2-16GB',
    hash_rate: 69.8888,
  },
  {
    id: 38,
    cuda_type: 'NVIDIA GeForce RTX 3070 Ti',
    hash_rate: 68.4512,
  },
  {
    id: 256,
    cuda_type: 'RTX A4500',
    hash_rate: 67.88,
  },
  {
    id: 150,
    cuda_type: 'NVIDIA TITAN V',
    hash_rate: 67.4133,
  },
  {
    id: 145,
    cuda_type: 'gfx906:sramecc-:xnack- OpenCL 2.0',
    hash_rate: 65.75,
  },
  {
    id: 238,
    cuda_type: 'RTX 4070 SUPER',
    hash_rate: 64.56,
  },
  {
    id: 49,
    cuda_type: 'NVIDIA GeForce RTX 4070 Ti',
    hash_rate: 63.3638,
  },
  {
    id: 211,
    cuda_type: 'RTX A4000',
    hash_rate: 63.2083,
  },
  {
    id: 196,
    cuda_type: 'RTX 3070 Laptop GPU',
    hash_rate: 62.843,
  },
  {
    id: 207,
    cuda_type: 'RTX 4070 Ti',
    hash_rate: 62.682,
  },
  {
    id: 200,
    cuda_type: 'RTX 3080 Laptop GPU',
    hash_rate: 62.365,
  },
  {
    id: 227,
    cuda_type: 'gfx1011',
    hash_rate: 62.0747,
  },
  {
    id: 240,
    cuda_type: 'TITAN RTX',
    hash_rate: 61.62,
  },
  {
    id: 4,
    cuda_type: 'gfx1011:xnack- OpenCL 2.0',
    hash_rate: 59.6177,
  },
  {
    id: 163,
    cuda_type: '',
    hash_rate: 59.5264,
  },
  {
    id: 43,
    cuda_type: 'NVIDIA GeForce RTX 3080 Ti Laptop GPU',
    hash_rate: 59.3238,
  },
  {
    id: 218,
    cuda_type: 'gfx1011:xnack-',
    hash_rate: 59.2544,
  },
  {
    id: 190,
    cuda_type: 'RTX 2080 Ti',
    hash_rate: 59.01,
  },
  {
    id: 198,
    cuda_type: 'RTX 3070 Ti Laptop GPU',
    hash_rate: 58.836,
  },
  {
    id: 6,
    cuda_type: 'gfx1030 OpenCL 2.0',
    hash_rate: 58.4982,
  },
  {
    id: 165,
    cuda_type: 'gfx1030',
    hash_rate: 57.58,
  },
  {
    id: 213,
    cuda_type: 'Graphics Device',
    hash_rate: 57.07,
  },
  {
    id: 251,
    cuda_type: 'Tesla V100-PCIE-12GB',
    hash_rate: 56.995,
  },
  {
    id: 214,
    cuda_type: 'A10G',
    hash_rate: 56.7121,
  },
  {
    id: 181,
    cuda_type: 'NVIDIA A10G',
    hash_rate: 56.66,
  },
  {
    id: 234,
    cuda_type: 'gfx1101',
    hash_rate: 56.51,
  },
  {
    id: 48,
    cuda_type: 'NVIDIA GeForce RTX 4070',
    hash_rate: 56.454,
  },
  {
    id: 195,
    cuda_type: 'RTX 3070',
    hash_rate: 56.2992,
  },
  {
    id: 194,
    cuda_type: 'RTX 3060 Ti',
    hash_rate: 56.2104,
  },
  {
    id: 206,
    cuda_type: 'RTX 4070',
    hash_rate: 55.607,
  },
  {
    id: 162,
    cuda_type: 'Quadro RTX 6000',
    hash_rate: 55.33,
  },
  {
    id: 250,
    cuda_type: 'CMP 100-210',
    hash_rate: 55.25,
  },
  {
    id: 37,
    cuda_type: 'NVIDIA GeForce RTX 3070 Laptop GPU',
    hash_rate: 54.519,
  },
  {
    id: 41,
    cuda_type: 'NVIDIA GeForce RTX 3080 Laptop GPU',
    hash_rate: 54.029,
  },
  {
    id: 164,
    cuda_type: 'gfx1010',
    hash_rate: 53.72,
  },
  {
    id: 217,
    cuda_type: 'gfx1010:xnack-',
    hash_rate: 51.9789,
  },
  {
    id: 36,
    cuda_type: 'NVIDIA GeForce RTX 3070',
    hash_rate: 51.7347,
  },
  {
    id: 35,
    cuda_type: 'NVIDIA GeForce RTX 3060 Ti',
    hash_rate: 51.278,
  },
  {
    id: 154,
    cuda_type: 'gfx1010 OpenCL 2.0 AMD-APP',
    hash_rate: 51.0092,
  },
  {
    id: 32,
    cuda_type: 'NVIDIA GeForce RTX 2080 Ti',
    hash_rate: 50.8037,
  },
  {
    id: 58,
    cuda_type: 'NVIDIA RTX A4000',
    hash_rate: 50.2803,
  },
  {
    id: 3,
    cuda_type: 'gfx1010:xnack- OpenCL 2.0',
    hash_rate: 49.4919,
  },
  {
    id: 170,
    cuda_type: 'CMP 50HX',
    hash_rate: 49.071,
  },
  {
    id: 14,
    cuda_type: 'NVIDIA CMP 50HX',
    hash_rate: 47.9439,
  },
  {
    id: 34,
    cuda_type: 'NVIDIA GeForce RTX 3060 Laptop GPU',
    hash_rate: 47.9362,
  },
  {
    id: 151,
    cuda_type: 'gfx1013:xnack- OpenCL 2.0',
    hash_rate: 46.9,
  },
  {
    id: 39,
    cuda_type: 'NVIDIA GeForce RTX 3070 Ti Laptop GPU',
    hash_rate: 46.3366,
  },
  {
    id: 187,
    cuda_type: 'RTX 2070 SUPER',
    hash_rate: 43.28,
  },
  {
    id: 220,
    cuda_type: 'gfx1031',
    hash_rate: 43.2206,
  },
  {
    id: 7,
    cuda_type: 'gfx1031 OpenCL 2.0',
    hash_rate: 42.7153,
  },
  {
    id: 185,
    cuda_type: 'RTX 2060 SUPER',
    hash_rate: 42.6862,
  },
  {
    id: 189,
    cuda_type: 'RTX 2080 SUPER',
    hash_rate: 42.27,
  },
  {
    id: 188,
    cuda_type: 'RTX 2080',
    hash_rate: 41.91,
  },
  {
    id: 264,
    cuda_type: 'gfx901',
    hash_rate: 41.73,
  },
  {
    id: 33,
    cuda_type: 'NVIDIA GeForce RTX 3060',
    hash_rate: 41.668,
  },
  {
    id: 192,
    cuda_type: 'RTX 3060',
    hash_rate: 41.5206,
  },
  {
    id: 231,
    cuda_type: 'RTX 2070 with Max-Q Design',
    hash_rate: 40.09,
  },
  {
    id: 186,
    cuda_type: 'RTX 2070',
    hash_rate: 39.8533,
  },
  {
    id: 193,
    cuda_type: 'RTX 3060 Laptop GPU',
    hash_rate: 39.7819,
  },
  {
    id: 236,
    cuda_type: 'NVIDIA GeForce RTX 4060',
    hash_rate: 39.09,
  },
  {
    id: 30,
    cuda_type: 'NVIDIA GeForce RTX 2080',
    hash_rate: 38.5096,
  },
  {
    id: 232,
    cuda_type: 'gfx1013',
    hash_rate: 37.7175,
  },
  {
    id: 29,
    cuda_type: 'NVIDIA GeForce RTX 2070 SUPER',
    hash_rate: 37.5841,
  },
  {
    id: 215,
    cuda_type: 'CMP 40HX',
    hash_rate: 37.4506,
  },
  {
    id: 13,
    cuda_type: 'NVIDIA CMP 40HX',
    hash_rate: 37.1418,
  },
  {
    id: 210,
    cuda_type: 'RTX A2000',
    hash_rate: 36.8558,
  },
  {
    id: 27,
    cuda_type: 'NVIDIA GeForce RTX 2060 SUPER',
    hash_rate: 36.749,
  },
  {
    id: 62,
    cuda_type: 'Quadro RTX 4000',
    hash_rate: 36.5444,
  },
  {
    id: 28,
    cuda_type: 'NVIDIA GeForce RTX 2070',
    hash_rate: 36.0482,
  },
  {
    id: 204,
    cuda_type: 'RTX 4060',
    hash_rate: 35.42,
  },
  {
    id: 31,
    cuda_type: 'NVIDIA GeForce RTX 2080 SUPER',
    hash_rate: 35.2063,
  },
  {
    id: 53,
    cuda_type: 'NVIDIA P102-100',
    hash_rate: 35.1534,
  },
  {
    id: 205,
    cuda_type: 'RTX 4060 Ti',
    hash_rate: 34.825,
  },
  {
    id: 229,
    cuda_type: 'gfx1013:xnack-',
    hash_rate: 34.675,
  },
  {
    id: 9,
    cuda_type: 'gfx900:xnack- OpenCL 2.0',
    hash_rate: 34.5732,
  },
  {
    id: 246,
    cuda_type: 'Quadro RTX 5000',
    hash_rate: 34.48,
  },
  {
    id: 225,
    cuda_type: 'P102-100',
    hash_rate: 33.8888,
  },
  {
    id: 177,
    cuda_type: 'GTX 1080 Ti',
    hash_rate: 33.745,
  },
  {
    id: 47,
    cuda_type: 'NVIDIA GeForce RTX 4060 Ti',
    hash_rate: 33.5922,
  },
  {
    id: 56,
    cuda_type: 'NVIDIA RTX A2000',
    hash_rate: 33.5341,
  },
  {
    id: 22,
    cuda_type: 'NVIDIA GeForce GTX 1080 Ti',
    hash_rate: 32.8703,
  },
  {
    id: 239,
    cuda_type: 'RTX A2000 12GB',
    hash_rate: 32.52,
  },
  {
    id: 57,
    cuda_type: 'NVIDIA RTX A2000 12GB',
    hash_rate: 32.4891,
  },
  {
    id: 222,
    cuda_type: 'gfx900:xnack-',
    hash_rate: 32.2363,
  },
  {
    id: 64,
    cuda_type: 'Tesla P100-SXM2-16GB',
    hash_rate: 32.08,
  },
  {
    id: 235,
    cuda_type: 'gfx1102',
    hash_rate: 31.92,
  },
  {
    id: 179,
    cuda_type: 'GTX 1660 SUPER',
    hash_rate: 31.2938,
  },
  {
    id: 152,
    cuda_type: 'gfx1032 OpenCL 2.0 AMD-APP',
    hash_rate: 31.0565,
  },
  {
    id: 169,
    cuda_type: 'CMP 30HX',
    hash_rate: 30.9412,
  },
  {
    id: 180,
    cuda_type: 'GTX 1660 Ti',
    hash_rate: 30.916,
  },
  {
    id: 158,
    cuda_type: 'gfx1102 OpenCL 2.0',
    hash_rate: 30.79,
  },
  {
    id: 259,
    cuda_type: 'Quadro P6000',
    hash_rate: 30.58,
  },
  {
    id: 65,
    cuda_type: 'Tesla P40',
    hash_rate: 30.53,
  },
  {
    id: 191,
    cuda_type: 'RTX 3050',
    hash_rate: 29.67,
  },
  {
    id: 253,
    cuda_type: 'RTX 4060 Laptop GPU',
    hash_rate: 29.53,
  },
  {
    id: 8,
    cuda_type: 'gfx1032 OpenCL 2.0',
    hash_rate: 29.2942,
  },
  {
    id: 221,
    cuda_type: 'gfx1032',
    hash_rate: 29.0219,
  },
  {
    id: 182,
    cuda_type: 'P104-100',
    hash_rate: 28.92,
  },
  {
    id: 261,
    cuda_type: 'NVIDIA L4',
    hash_rate: 28.86,
  },
  {
    id: 63,
    cuda_type: 'Tesla P100-PCIE-16GB',
    hash_rate: 28.535,
  },
  {
    id: 184,
    cuda_type: 'RTX 2060',
    hash_rate: 28.23,
  },
  {
    id: 12,
    cuda_type: 'NVIDIA CMP 30HX',
    hash_rate: 27.6549,
  },
  {
    id: 175,
    cuda_type: 'GTX 1070 Ti',
    hash_rate: 27.5222,
  },
  {
    id: 216,
    cuda_type: 'Ellesmere',
    hash_rate: 27.3263,
  },
  {
    id: 2,
    cuda_type: 'Ellesmere OpenCL 2.0 AMD-APP',
    hash_rate: 27.3,
  },
  {
    id: 20,
    cuda_type: 'NVIDIA GeForce GTX 1070 Ti',
    hash_rate: 27.0594,
  },
  {
    id: 228,
    cuda_type: 'gfx1012',
    hash_rate: 27,
  },
  {
    id: 24,
    cuda_type: 'NVIDIA GeForce GTX 1660 SUPER',
    hash_rate: 26.9446,
  },
  {
    id: 157,
    cuda_type: 'GeForce RTX 2060',
    hash_rate: 26.8175,
  },
  {
    id: 46,
    cuda_type: 'NVIDIA GeForce RTX 4060 Laptop GPU',
    hash_rate: 26.72,
  },
  {
    id: 5,
    cuda_type: 'gfx1012:xnack- OpenCL 2.0',
    hash_rate: 26.2873,
  },
  {
    id: 54,
    cuda_type: 'NVIDIA P104-100',
    hash_rate: 26.2756,
  },
  {
    id: 1,
    cuda_type: 'Ellesmere OpenCL 1.2 AMD-APP',
    hash_rate: 25.921,
  },
  {
    id: 147,
    cuda_type: 'NVIDIA GeForce RTX 3050',
    hash_rate: 25.78,
  },
  {
    id: 26,
    cuda_type: 'NVIDIA GeForce RTX 2060',
    hash_rate: 25.5355,
  },
  {
    id: 25,
    cuda_type: 'NVIDIA GeForce GTX 1660 Ti',
    hash_rate: 25.3998,
  },
  {
    id: 219,
    cuda_type: 'gfx1012:xnack-',
    hash_rate: 24.88,
  },
  {
    id: 176,
    cuda_type: 'GTX 1080',
    hash_rate: 24.7156,
  },
  {
    id: 178,
    cuda_type: 'GTX 1660',
    hash_rate: 24.125,
  },
  {
    id: 153,
    cuda_type: 'Quadro P4200',
    hash_rate: 24.05,
  },
  {
    id: 160,
    cuda_type: 'NVIDIA RTX A2000 Laptop GPU',
    hash_rate: 22.6425,
  },
  {
    id: 21,
    cuda_type: 'NVIDIA GeForce GTX 1080',
    hash_rate: 21.4699,
  },
  {
    id: 23,
    cuda_type: 'NVIDIA GeForce GTX 1660',
    hash_rate: 21.3997,
  },
  {
    id: 263,
    cuda_type: 'NVIDIA GeForce RTX 4070 SUPER',
    hash_rate: 21.2325,
  },
  {
    id: 260,
    cuda_type: 'MX230',
    hash_rate: 21.11,
  },
  {
    id: 174,
    cuda_type: 'GTX 1070',
    hash_rate: 20.9588,
  },
  {
    id: 159,
    cuda_type: 'NVIDIA GeForce GTX 1060',
    hash_rate: 20.54,
  },
  {
    id: 241,
    cuda_type: 'GTX 1060',
    hash_rate: 20.1991,
  },
  {
    id: 19,
    cuda_type: 'NVIDIA GeForce GTX 1070',
    hash_rate: 19.713,
  },
  {
    id: 272,
    cuda_type: 'A16',
    hash_rate: 19.06,
  },
  {
    id: 245,
    cuda_type: 'Quadro P4000',
    hash_rate: 19.02,
  },
  {
    id: 242,
    cuda_type: 'GTX 1060 3GB',
    hash_rate: 18.3803,
  },
  {
    id: 162,
    cuda_type: 'Tonga OpenCL 2.0 AMD-APP',
    hash_rate: 18.25,
  },
  {
    id: 55,
    cuda_type: 'NVIDIA P106-100',
    hash_rate: 17.6796,
  },
  {
    id: 17,
    cuda_type: 'NVIDIA GeForce GTX 1060 3GB',
    hash_rate: 17.55,
  },
  {
    id: 173,
    cuda_type: 'GTX 1060 6GB',
    hash_rate: 17.4025,
  },
  {
    id: 230,
    cuda_type: 'gfx900',
    hash_rate: 17.1863,
  },
  {
    id: 18,
    cuda_type: 'NVIDIA GeForce GTX 1060 6GB',
    hash_rate: 17.1215,
  },
  {
    id: 183,
    cuda_type: 'P106-100',
    hash_rate: 16.4159,
  },
  {
    id: 237,
    cuda_type: 'P106-090',
    hash_rate: 10.98,
  },
  {
    id: 148,
    cuda_type: 'NVIDIA P106-090',
    hash_rate: 9.6887,
  },
  {
    id: 255,
    cuda_type: 'GTX 1650',
    hash_rate: 1.52,
  },
  {
    id: 254,
    cuda_type: 'Baffin',
    hash_rate: 1.44,
  },
  {
    id: 149,
    cuda_type: 'Quadro M4000',
    hash_rate: 1.38,
  },
  {
    id: 266,
    cuda_type: 'Quadro P600',
    hash_rate: 1.375,
  },
  {
    id: 257,
    cuda_type: 'RTX 3050 Laptop GPU',
    hash_rate: 1.36,
  },
  {
    id: 243,
    cuda_type: 'GTX 1650 Ti',
    hash_rate: 1.32,
  },
  {
    id: 224,
    cuda_type: 'GT 1030',
    hash_rate: 0.52,
  },
  {
    id: 146,
    cuda_type: 'Tesla T4',
    hash_rate: 0.0654,
  },
];
